import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Helper } from '@piqet-angular/data';
import { MustMatch } from './must-match.validator';
@Component({
  selector: 'piqet-angular-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent {
  changePasswordForm!: FormGroup;
  fieldTextType = false;
  @Input() userProfileOverview: any;
  @Output() changePassword = new EventEmitter<any>();
  fieldTextTypeNewPwd = false;
  fieldTextTypeConfirmPwd = false;
  specialCharactersflag: boolean = true;
  upperCaseCharactersflag: boolean = true;
  lowerCaseCharactersflag: boolean = true;
  numberCharactersflag: boolean = true;
  minLengthsflag: boolean = true;
  isErrorpwd: boolean = false;
  submitted: boolean = true;
  constructor(private formBuilder: FormBuilder, private helper: Helper) {}

  ngOnInit() {
    const pwdReg = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
    this.changePasswordForm = this.formBuilder.group(
      {
        oldPassword: ['', Validators.required],
        Password: [null, [Validators.required, Validators.pattern(pwdReg)]],
        ConfirmPassword: ['', Validators.required],
      },
      {
        validator: MustMatch('Password', 'ConfirmPassword'),
      }
    );
  }
  comparePasswords() {
    if (
      this.changePasswordForm.controls['oldPassword'].value ==
      this.changePasswordForm.controls['Password'].value
    ) {
      this.isErrorpwd = true;
      this.submitted = false;
    } else {
      this.isErrorpwd = false;
      this.submitted = true;
    }
  }
  validationsPassword() {
    this.comparePasswords();
    const isValidate = Helper.passwordValidatior(
      this.changePasswordForm.controls['Password'].value
    );
    this.upperCaseCharactersflag = isValidate.upperCaseCharactersflag;
    this.lowerCaseCharactersflag = isValidate.lowerCaseCharactersflag;
    this.numberCharactersflag = isValidate.numberCharactersflag;
    this.specialCharactersflag = isValidate.specialCharactersflag;
    this.minLengthsflag = isValidate.minLengthsflag;
  }

  toggleFieldOldPwd() {
    this.fieldTextType = !this.fieldTextType;
  }
  toggleFieldNewPwd() {
    this.fieldTextTypeNewPwd = !this.fieldTextTypeNewPwd;
  }
  toggleFieldConfirmPwd() {
    this.fieldTextTypeConfirmPwd = !this.fieldTextTypeConfirmPwd;
  }

  submit() {
    if (!this.changePasswordForm.valid) {
      this.changePasswordForm.get('oldPassword')?.markAsTouched();
      this.changePasswordForm.get('Password')?.markAsTouched();
      this.changePasswordForm.get('ConfirmPassword')?.markAsTouched();
      return;
    }
    const data = {
      Email: this.userProfileOverview.userName,
      OldPassword: this.changePasswordForm.controls['oldPassword'].value,
      Password: this.changePasswordForm.controls['Password'].value,
      PasswordRepeat: this.changePasswordForm.controls['ConfirmPassword'].value,
    };
    this.changePassword.emit(data);
    this.changePasswordForm.reset();
  }
}
